<!-- Remove the hide class to show the  creation of manual alert datacard -->
<app-loader *ngIf="showLoader" [loaderType]="loaderType" [loaderMsg]="showLoader"></app-loader>

<!-- <div class="col-md-12 manual-alert hide1">
        <f-data-card class="pos-relative"> -->
<!-- hide the refresh button  
        <button mat-button color="primary" title="Refresh" class="btn-refresh">
        <i class="fa-solid fa-arrows-rotate"></i>
      </button> -->
<h2 class="heading">Attention!</h2>
<!-- Below msg display in case no alert -->
<section class="error-wrapper"
    *ngIf="custAlertsService?.alertListDataMap[this.rootScope.activeCustTab.customerSessionId]?.isAPIError">
    <section class="error-wrapper">
        <f-alert variant="error">
            <p>{{alertListErrMsg}} <a href="javascript:void('0')" (click)="getAllAlerts()">
                    Try again</a> </p>
        </f-alert>
    </section>
</section>
<p class="no-result hide1"
    *ngIf="!custAlertsService?.alertListDataMap[this.rootScope.activeCustTab.customerSessionId]?.isAPIError && alertList?.length==0">
    There are no attention items.
</p>
<mat-accordion class="manual-alert">
    <ng-container *ngFor="let alert of alertList; trackBy: trackItem">
        <mat-expansion-panel [ngClass]="alert?.isReviwed ? 'reviewed' : ''" [expanded]="alert?.isOpen"
            (opened)="openAccordian(alert)" (closed)="closeAccordian(alert)">
            <mat-expansion-panel-header [class.linkDisabled]='disableAlert'>

                <div class="panel-title" (click)="$event.stopPropagation();">
                    <h3>
                        {{alert.headline}}
                    </h3>
                    <span class="deadline-date red" *ngIf="alert?.deadlineDate">Deadline:
                        {{alert.deadlineDate}}</span>
                </div>
                <span class="reviewflag" *ngIf="alert?.isReviwed">Reviewed</span>
            </mat-expansion-panel-header>
            <div class="panel-body">
                <div class="body-header-CTA">
                    <button class="more-info"><span class="hide">More info</span></button>
                    <!-- <button [ngClass]="!enableAlertEdit(alert) ? 'edit-alert' : ''"  (click)="editAlert(alert)"> -->
                    <button *ngIf="!enableAlertEdit(alert)" [disabled]='true' class="edit-alert"
                        (click)="editAlert(alert)">
                        Edit <i class="fa-regular fa-pen-to-square"></i>
                    </button>

                    <button *ngIf="enableAlertEdit(alert)" (click)="editAlert(alert)">
                        Edit <i class="fa-regular fa-pen-to-square"></i>
                    </button>


                </div>

                <section class="error-wrapper" *ngIf="alert?.displaySaveAlertErrMsg">
                    <f-alert variant="error">{{ saveAlertFailMsg}}</f-alert>
                </section>
                <div class="alert-fields form">
                    <div class="alert-field left">
                        <span class="form-label">Author</span>
                        <span class="form-value"> {{alert.authorName}}</span>
                    </div>
                    <div class="alert-field center">
                        <span class="form-label">Creation date</span>
                        <span class="form-value">{{alert.created}}</span>
                    </div>
                    <div class="alert-field right">
                        <span class="form-label">Expiration date</span>
                        <span class="form-value">{{alert.expired}}</span>
                    </div>
                    <div class="alert-field left alert-title">
                        <span class="form-label">Title</span>
                        <span class="form-value" *ngIf="!alert.enableAlertEdit">{{alert.headline}}</span>
                        <mat-form-field *ngIf="alert.enableAlertEdit" appearance="fill" class="component-box">
                            <!-- {{alert.editTitle}} -->
                            <input matInput [(ngModel)]="alert.editTitle" id="headline" placeholder="headline" />
                        </mat-form-field>
                    </div>

                    <div class="alert-field left alert-description">
                        <span class="form-label">Details</span>
                        <span class="form-value" *ngIf="!alert.enableAlertEdit">
                            {{alert.detail}}
                        </span>

                        <!-- {{alert.editDesc}} -->
                        <mat-form-field *ngIf="alert.enableAlertEdit" appearance="fill"
                            class="component-box description-input">
                            <textarea [(ngModel)]="alert.editDesc" matInput></textarea>
                        </mat-form-field>
                    </div>
                </div>


                <div class="edit-alert-CTA" *ngIf="alert.enableAlertEdit">
                    <f-button class="btn-alert create" text="Cancel" buttonTitle="Cancel" type="button"
                        (buttonClicked)="onEditCancelClick(alert)" variant="action">
                    </f-button>

                    <f-button text="Save" buttonTitle="save" type="button" variant="progressive"
                        (buttonClicked)="onEditSaveClick(alert)">
                    </f-button>
                </div>

                <div class="body-fotter-CTA">
                    <button mat-button1 color="primary" class="btn-alert"
                        (click)="reviewUnreview(alert.runtimeAlertId)">
                        <span *ngIf="!alert?.isReviwed"> <i class="fa-regular fa-circle-check"></i>
                            <span>Mark as reviewed</span></span>
                        <!-- this icon visible in case of marked reviewed  -->
                        <span *ngIf="alert?.isReviwed"> <i class="fa-solid fa-circle-check"></i>
                            <span>Mark as unreviewed</span></span>
                    </button>
                        
                    <button mat-button1 *ngIf="enableAlertEdit(alert) && !alert.disableDelete"  color="primary" class="btn-delete" (click)="deleteAlert(alert)">
                        <span>Delete</span>
                        <i class="fa-light fa-trash-can"></i>
                    </button>

                    <button mat-button1 *ngIf="enableAlertEdit(alert) && alert.disableDelete" [disabled]='true' color="primary" class="btn-delete" (click)="deleteAlert(alert)">
                        <span>Delete</span>
                        <i class="fa-light fa-trash-can"></i>
                    </button> 
                                </div>

                <div class="confirm-dialog" *ngIf="alert?.showDeleteAlert">
                    <p>Are you sure you want to delete this alert?</p>

                    <button mat-button1 color="primary" class="btn-confirm-delete" (click)="performDelete(alert)">
                        <span>Delete</span>
                    </button>

                    <button mat-button1 color="primary" class="btn-cancel" (click)="closeDeleteAlert(alert)">
                        <span>Cancel</span>
                    </button>
                </div>
            </div>
        </mat-expansion-panel>
    </ng-container>
</mat-accordion>

<!-- locked attention alert msg here-->
<div class="locked-alerts" *ngIf="showLockedAlertMsg">
    <p><i class="fa-light fa-lock"></i> Secure the call to view locked attention items <span
            class="alert-count">( {{noOfLockedAlerts}} )</span> </p>
</div>

<!-- Below button used for create alert -->
<div class="create-alert-row">

    <f-button [iconConfig]="iconConfig" class="btn-alert create" text="Create an alert" buttonTitle="Create an alert"
        type="button" variant="progressive" (click)="openCreateAlert()">
    </f-button>

    <!-- <button mat-button color="primary" class="btn-alert Expired" (click)="expiredAlert()">
                    <i class="fa-solid fa-eye"></i>
                    <span>View expired </span>
                </button> -->
</div>
<!-- </f-data-card>
</div> -->




<!-- <div class="expand-collapse-panel">
                <div class="panel-header">
                    <div class="panel-title">
                        <h3>
                            Care Portal
                            <button mat-button1 color="primary" class="show-hide" id="toggle-1"
                                (click)="showContent2 = !showContent2">
                                <span *ngIf="showContent2"><i class="fa-regular fa-angle-down"></i></span>
                                <span *ngIf="!showContent2"><i class="fa-regular fa-angle-up"></i></span>
                            </button>
                        </h3>
                    </div>
                </div>
                <div class="panel-body" *ngIf="!showContent2">
                    <div class="body-header-CTA">
                        <button class="more-info">More info</button>
                        <button class="edit-alert">
                            Edit <i class="fa-regular fa-pen-to-square"></i>
                        </button>
                    </div>
                    <div class="alert-fields form show-edit-form">
                        <div class="alert-field left">
                            <span class="form-label">Author</span>
                            <span class="form-value">Kumar Vidoth</span>
                        </div>
                        <div class="alert-field center">
                            <span class="form-label">Created</span>
                            <span class="form-value">test date</span>
                        </div>
                        <div class="alert-field right">
                            <span class="form-label">Expired</span>
                            <span class="form-value">test date</span>
                        </div>
                        <div class="alert-field left alert-title">
                            <span class="form-label">Title</span>
                            <span class="form-value hide">Testing title for this screen</span>
                            <mat-form-field appearance="fill" class="component-box">
                                <input matInput formControlName="title" id="title" placeholder="Title" />
                            </mat-form-field>
                        </div>

                        <div class="alert-field left alert-description">
                            <span class="form-label">Description</span>
                            <span class="form-value hide">Lorem ipsum dolor sit amet, consectetur adipiscing
                                elit. Aenean dictum ornare ultrices. Morbi luctus leo
                                vitae dignissim ultricies. Vestibulum rutrum leo eros,
                                pellentesque blandit libero posuere sed. Donec turpis
                                sem, aliquam non augue non, pretium luctus justo.
                                Vestibulum auctor nisi non augue tempus fringilla.
                                Integer ut tincidunt eros, id placerat urna.</span>

                            <mat-form-field appearance="fill" class="component-box description-input">
                                <textarea matInput placeholder="Lorem ipsum dolor sit amet......"></textarea>
                            </mat-form-field>
                        </div>
                    </div>


                    <div class="edit-alert-CTA">
                        <f-button class="btn-alert create" text="Cancel" buttonTitle="Cancel" type="button"
                            variant="action">
                        </f-button>

                        <f-button text="Save" buttonTitle="save" type="button" variant="progressive">
                        </f-button>
                    </div>

                    <div class="body-fotter-CTA hide">
                        <button mat-button1 color="primary" class="btn-alert">
                            <span>Mark as reviewed</span>
                        </button>

                        <button mat-button1 color="primary" class="btn-delete" (click)="deleteAlert()">
                            <span>Delete</span>
                            <i class="fa-light fa-trash-can"></i>
                        </button>
                    </div>

                    <div class="body-fotter-CTA hide1">
                        <button mat-button1 color="primary" class="btn-alert">
                            <i class="fa-regular fa-circle-check"></i>

                            <span>Mark as reviewed</span>
                        </button>

                        <button mat-button1 color="primary" class="btn-delete" (click)="deleteAlert()">
                            <span>Delete</span>
                            <i class="fa-light fa-trash-can"></i>
                        </button>
                    </div>

                    <div class="confirm-dialog" *ngIf="showDeleteAlert">
                        <p>Are you sure you want to delete this alert?</p>

                        <button mat-button1 color="primary" class="btn-confirm-delete">
                            <span>Delete</span>
                        </button>

                        <button mat-button1 color="primary" class="btn-cancel" (click)="closeDeleteAlert()">
                            <span>Cancel</span>
                        </button>
                    </div>
                </div>
            </div> -->

<!-- <div class="expand-collapse-panel reviewed">
                <div class="panel-header">
                    <div class="panel-title">
                        <h3>
                            Bad mobile phone number on file

                            <button mat-button1 color="primary" class="show-hide" id="toggle-1"
                                (click)="showContent3 = !showContent3">
                                <span *ngIf="showContent3"><i class="fa-regular fa-angle-down"></i></span>
                                <span *ngIf="!showContent3"><i class="fa-regular fa-angle-up"></i></span>
                            </button>
                        </h3>
                    </div>

                    <span class="reviewflag">Reviewed</span>
                </div>
                <div class="panel-body" *ngIf="!showContent3">
                    <div class="body-header-CTA">
                        <button class="more-info">More info</button>
                        <button class="edit-alert">
                            Edit <i class="fa-regular fa-pen-to-square"></i>
                        </button>
                    </div>
                    <div class="alert-fields form">
                        <div class="alert-field left">
                            <span class="form-label">Author</span>
                            <span class="form-value">Kumar Vidoth</span>
                        </div>
                        <div class="alert-field center">
                            <span class="form-label">Created</span>
                            <span class="form-value">test date</span>
                        </div>
                        <div class="alert-field right">
                            <span class="form-label">Expired</span>
                            <span class="form-value">test date</span>
                        </div>
                        <div class="alert-field left alert-title">
                            <span class="form-label">Title</span>
                            <span class="form-value">Testing title for this screen</span>
                        </div>

                        <div class="alert-field left alert-description">
                            <span class="form-label">Description</span>
                            <span class="form-value">Lorem ipsum dolor sit amet, consectetur adipiscing
                                elit. Aenean dictum ornare ultrices. Morbi luctus leo
                                vitae dignissim ultricies. Vestibulum rutrum leo eros,
                                pellentesque blandit libero posuere sed. Donec turpis
                                sem, aliquam non augue non, pretium luctus justo.
                                Vestibulum auctor nisi non augue tempus fringilla.
                                Integer ut tincidunt eros, id placerat urna.</span>
                        </div>
                    </div>
                    <div class="body-fotter-CTA">
                        <button mat-button1 color="primary" class="btn-alert">

                            <i class="fa-solid fa-circle-check"></i>

                            <span>Mark as reviewed</span>
                        </button>

                        <button mat-button1 color="primary" class="btn-delete">
                            <span>Delete</span>
                            <i class="fa-light fa-trash-can"></i>
                        </button>
                    </div>
                </div>
            </div> -->

<!-- <div class="expand-collapse-panel reviewed">
                <div class="panel-header">
                    <div class="panel-title">
                        <h3>
                            Test
                            <button mat-button1 color="primary" class="show-hide" id="toggle-1"
                                (click)="showContent4 = !showContent4">
                                <span *ngIf="showContent4"><i class="fa-regular fa-angle-down"></i></span>
                                <span *ngIf="!showContent4"><i class="fa-regular fa-angle-up"></i></span>
                            </button>
                        </h3>
                    </div>

                    <span class="reviewflag">Reviewed</span>
                </div>
                <div class="panel-body" *ngIf="!showContent4">
                    <div class="body-header-CTA">
                        <button class="more-info">More info</button>
                        <button class="edit-alert">
                            Edit <i class="fa-regular fa-pen-to-square"></i>
                        </button>
                    </div>
                    <div class="alert-fields form">
                        <div class="alert-field left">
                            <span class="form-label">Author</span>
                            <span class="form-value">Kumar Vidoth</span>
                        </div>
                        <div class="alert-field center">
                            <span class="form-label">Created</span>
                            <span class="form-value">test date</span>
                        </div>
                        <div class="alert-field right">
                            <span class="form-label">Expired</span>
                            <span class="form-value">test date</span>
                        </div>
                        <div class="alert-field left alert-title">
                            <span class="form-label">Title</span>
                            <span class="form-value">Testing title for this screen</span>
                        </div>

                        <div class="alert-field left alert-description">
                            <span class="form-label">Description</span>
                            <span class="form-value">Lorem ipsum dolor sit amet, consectetur adipiscing
                                elit. Aenean dictum ornare ultrices. Morbi luctus leo
                                vitae dignissim ultricies. Vestibulum rutrum leo eros,
                                pellentesque blandit libero posuere sed. Donec turpis
                                sem, aliquam non augue non, pretium luctus justo.
                                Vestibulum auctor nisi non augue tempus fringilla.
                                Integer ut tincidunt eros, id placerat urna.</span>
                        </div>
                    </div>
                   
                    <div class="body-fotter-CTA">
                        <button mat-button1 color="primary" class="btn-alert">
                          
                            <i class="fa-solid fa-circle-check"></i>
                            <span>Mark as reviewed</span>
                        </button>

                        <button mat-button1 color="primary" class="btn-delete">
                            <span>Delete</span>
                            <i class="fa-light fa-trash-can"></i>
                        </button>
                    </div>
                </div>
            </div> -->
<!-- Below button used for create alert -->